export const CATQ = 
{
    Metadata:{Name:'CAT-Q',maxColumn:7,numRows:25},
    Sections:
    [
        {
            Headers:[
                "Please read each statement below and circle the answer that best fits your experiences during social interactions.",
                "Strongly Disagree",
                "Disagree",
                "Somewhat Disagree",
                "Neither Agree nor Disagree",
                "Somewhat Agree",
                "Agree",
                "Strongly Agree"
            ],
            Questions:[
                {
                    Prompt:"1. When I am interacting with someone, I deliberately copy their body language or facial expressions.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"2. I monitor my body language or facial expressions so that I appear relaxed.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"3. I rarely feel the need to put on an act to get through a social situation",
                    Responses:[
                        {Value:7,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"},
                    ]
                },
                {
                    Prompt:"4. I have developed a script to follow in social situations.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"5. I will repeat phrases that I have heard others say in the exact same way that I first heard them.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"6. I adjust my body language or facial expressions so that I appear interested by the person I am interacting with.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"7. In social situations, I feel like I'm 'performing' rather than being myself.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"8. In my own social interactions, I use behaviors that I have learned from watching other people interacting.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"9. I always think about the impression I make on other people.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"10. I need the support of other people to socialize.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"11. I practice my facial expressions and body language to make sure they look natural.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"12. I don't feel the need to make eye contact with other people if I don't want to.",
                    Responses:[
                        {Value:7,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"},
                    ]
                },
                {
                    Prompt:"13. I must force myself to interact with people when I am in social situations.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"14. I have tried to improve my understanding of social skills by watching other people.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"15. I monitor my body language or facial expressions so that I appear interested by the person I am interacting with.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"16. When in social situations, I try to find ways to avoid interacting with others.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"17. I have researched the rules of social interactions to improve my own social skills.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"18. I am always aware of the impression I make on other people.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"19. I feel free to be myself when I am with other people",
                    Responses:[
                        {Value:7,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"},
                    ]
                },
                {
                    Prompt:"20. I learn how people use their bodies and faces to interact by watching television or films, or by reading fiction.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"21. I adjust my body language or facial expressions so that I appear relaxed.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"22. When talking to other people, I feel like the conversation flows naturally",
                    Responses:[
                        {Value:7,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"},
                    ]
                },
                {
                    Prompt:"23. I have spent time learning social skills from television shows and films and try to use these in my interactions.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
                {
                    Prompt:"24. In social interactions, I do not pay attention to what my face or body are doing",
                    Responses:[
                        {Value:7,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:1,Type:"radio"},
                    ]
                },
                {
                    Prompt:"25. In social situations, I feel like I am pretending to be 'normal'.",
                    Responses:[
                        {Value:1,Type:"radio"},
                        {Value:2,Type:"radio"},
                        {Value:3,Type:"radio"},
                        {Value:4,Type:"radio"},
                        {Value:5,Type:"radio"},
                        {Value:6,Type:"radio"},
                        {Value:7,Type:"radio"},
                    ]
                },
            ]
        }
    ]
}